module.exports = __webpack_public_path__ + "static/media/star-three.2644df24.svg";